<template>
  <div class="orderList-page">
    <!-- 订单列表 -->
    <topNav :title="$t('orderList_title')"></topNav>
    <div class="ordertop"
         :class='{searchFix:searchPosition}'
         :style='{top:searchTop}'>
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <!-- 姓名/手机/登记单号 -->
        <input type="text"
               id='seachContent'
               v-model='searchOption.searchText'
               name=""
               :placeholder="$t('orderList_searchText_placeholder')">
        <div class="cleartext"
             v-show="searchOption.searchText != ''">
          <i class="iconfont icon-cuowu"
             @click="searchOption.searchText='';getOrderListNew()"></i>
        </div>
      </div>
      <!-- 搜索-->
      <div class="searchBtn"
           @click="getOrderListNew">{{$t('search')}}
      </div>
      <span class="line"></span>
      <!-- 筛选-->
      <mt-button @click.native="popupVisible3 = true">
        <div class="fliter">{{$t('fliter')}}<i class="iconfont icon-xia"></i></div>
      </mt-button>
    </div>
    <div class="oList">
      <div class="tags clearfix"
           :class='{posiTwo:fixedTwo}'
           :style='{top:PosiTop}'>
        <div style="width: 3000px">
          <!-- 有效预订-->
          <div class="tag"
               @click="getList(11)"
               :class="{active:searchOption.index==11}">
            {{$t('orderList_allReserve')}}
            ({{OrderCountForRoomNumber ? stateNum.allReserveRoom : stateNum.allReservePeople}})
          </div>
          <!-- 本日将到-->
          <div class="tag"
               @click="getList(1)"
               :class="{active:searchOption.index==1}">
            {{$t('orderList_notArr')}}
            ({{OrderCountForRoomNumber ? stateNum.notArrRoom : stateNum.notArrPeople}})
          </div>
          <!-- 本日已到-->
          <div class="tag"
               @click="getList(23)"
               :class="{active:searchOption.index==23}">
            {{$t('orderList_hasArr')}}
            ({{stateNum.hasArrRoom}})
          </div>
          <!-- 全部已到-->
          <div class="tag"
               @click="getList(25)"
               v-if="!isJingJiang"
               :class="{active:searchOption.index==25}">
            {{$t('orderList_allHasArr')}}
            ({{stateNum.allHasArrRoom}})
          </div>
          <!-- 未离-->
          <div class="tag"
               @click="getList(22)"
               :class="{active:searchOption.index==22}">
            {{$t('orderList_notDep')}}
            ({{stateNum.notDepRoom}})
          </div>
          <!-- 已离-->
          <div class="tag"
               @click="getList(24)"
               :class="{active:searchOption.index==24}">
            {{$t('orderList_hasDep')}}
            ({{stateNum.hasDepRoom}})
          </div>
          <!-- 今日新增-->
          <div class="tag"
               v-if="todayCreateOrder"
               @click="getList(88)"
               :class="{active:searchOption.index==88}">
            今日新增
            ({{stateNum.todayCreateOrder}})
          </div>
        </div>
      </div>

      <div class='state-num-bar'>
        <div v-show='searchOption.index==1'>
          {{$t('orderList_notArr')}} {{$t('orderList_total')}}
          <span class='red'>{{stateNum.notArrPeople}}</span>
          <small>{{$t('orderList_ordernum')}}</small>
          /
          <span class='red'>{{stateNum.notArrRoom}}</span>
          <small>{{$t('orderList_rmnum')}}</small>
        </div>
        <div v-show='searchOption.index==23'>
          {{$t('orderList_hasArr')}} {{$t('orderList_total')}}
          <span class='red'>{{stateNum.hasArrPeople}}</span>
          <small>{{$t('orderList_peoplenum')}}</small>
          /
          <span class='red'>{{stateNum.hasArrRoom}}</span>
          <small>{{$t('orderList_rmnum')}}</small>
        </div>

        <div v-show='searchOption.index==25'>
          {{$t('orderList_allHasArr')}} {{$t('orderList_total')}}
          <span class='red'>{{stateNum.allHasArrPeople}}</span>
          <small>{{$t('orderList_peoplenum')}}</small>
          /
          <span class='red'>{{stateNum.allHasArrRoom}}</span>
          <small>{{$t('orderList_rmnum')}}</small>
        </div>

        <div v-show='searchOption.index==22'>
          {{$t('orderList_notDep')}} {{$t('orderList_total')}}
          <span class='red'>{{stateNum.notDepPeople}}</span>
          <small>{{$t('orderList_peoplenum')}}</small>
          /
          <span class='red'>{{stateNum.notDepRoom}}</span>
          <small>{{$t('orderList_rmnum')}}</small>
        </div>
        <div v-show='searchOption.index==24'>
          {{$t('orderList_hasDep')}} {{$t('orderList_total')}}
          <span class='red'>{{stateNum.hasDepPeople}}</span>
          <small>{{$t('orderList_peoplenum')}}</small>
          /
          <span class='red'>{{stateNum.hasDepRoom}}</span>
          <small>{{$t('orderList_rmnum')}}</small>
        </div>
        <div v-show='searchOption.index==11'>
          {{$t('orderList_allReserve')}} {{$t('orderList_total')}}
          <span class='red'>{{stateNum.allReservePeople}}</span>
          <small>{{$t('orderList_ordernum')}}</small>
          /
          <span class='red'>{{stateNum.allReserveRoom}}</span>
          <small>{{$t('orderList_rmnum')}}</small>
        </div>
      </div>

      <ul class="list clearfix"
          v-infinite-scroll="getNextPage"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="20">
        <li class="item"
            v-for="(order,index) in orderList"
            :key="index">
          <div class="detailed">
            <div class="top clearfix">
              <!-- 订单号-->
              <p class="left">{{$t('orderList_rsvNo')}}：{{order.rsvNo}}</p>
              <mt-badge type="success"
                        v-if='rsvClassObj[order.rsvClass]'
                        size="small">
                {{rsvClassObj[order.rsvClass]}}
              </mt-badge>

              <mt-badge type="success"
                        color="#ccc"
                        class='right'
                        v-if='order.market'
                        size="small">
                {{order.market}}
              </mt-badge>
            </div>
            <router-link :to="link(order)">
              <div class="content clearfix">
                <ul>
                  <!-- 姓名-->
                  <li class="info">
                    {{$t('orderList_username')}}：{{order.username}}
                  </li>
                  <!-- 手机：-->
                  <li class="info">
                    {{$t('orderList_mobile')}}：{{order.mobile}}
                  </li>
                  <!-- 到离：-->
                  <li class="info">
                    {{$t('orderList_arr')}}：{{order.arr | dateF}}-{{order.dep | dateF}}
                  </li>
                  <!--间数：-->
                  <li class="info">
                    {{$t('orderList_rmnum')}}：{{order.rmnum}}
                  </li>
                  <!--房类：-->
                  <li class="info">
                    {{$t('orderList_rmtype')}}：{{order.rmtype}}
                  </li>
                  <!--房价：-->
                  <li class="info">
                    {{$t('orderList_realRate')}}：
                    <small>￥</small>
                    {{order.realRate}}
                  </li>
                  <!--卡号：-->
                  <li class="info">
                    {{$t('orderList_member_no')}}：{{order.member_no}}
                  </li>
                  <!--公司：-->
                  <li class="info">
                    {{$t('orderList_member_crpName')}}：<span>{{order.crpName}}</span>
                  </li>

                  <template v-if='order.showOther'>
                    <li class="info">
                      {{$t('fangT_rmno')}}：<span style='color: red;'>{{order.rmnub}}</span>
                    </li>

                    <li class="info"
                        style='width: 100%;display: flex;align-items: start; height: auto; padding-left: 13px;padding-right: 13px;'
                    >
                      <div>{{$t('remark')}}：</div>
                      <div style='white-space: normal; display: inline-block; width: 90%;'>{{order.remake}}</div>
                    </li>
                  </template>
                </ul>
                <i class="iconfont icon-you"></i>
              </div>
            </router-link>

            <div class='footer-btn'
                 :class="{'active': order.showOther}"
                 @click='toggleDetail(order)'>
              <i class='iconfont icon-xiaa'></i>
            </div>
          </div>
        </li>
        <div class="loadingli"
             v-show="loading">
          <mt-spinner :type="2"></mt-spinner>
        </div>
        <nothing :condition="orderList != null && orderList.length == 0"></nothing>
        <div class="dx"
             v-show="this.loading == false&&this.hasDx == true">
          <!-- —— 　我是有底线的　 —— -->
          {{$t('loading_end_message')}}
        </div>
      </ul>
    </div>
    <mt-popup v-model="popupVisible3"
              position="right"
              class="mint-popup-3 rightFliterBox"
              :modal="true">
      <div class="rightFliterBox">
        <!-- 筛选 -->
        <div class="filter_title"><span class="title"> {{$t('fliter')}}</span>
          <mt-button @click.native="popupVisible3 = false"><i class="iconfont icon-cuowu"></i></mt-button>
        </div>

        <div class="fliter_item">
          <!-- 销售员 -->
          <div class="category_name"><span> {{$t('orderList_category_name')}}</span>
            <!-- [清空] -->
            <p class="showCategory"
               @click="$refs.salesman.clear()">{{$t('orderList_showCategory')}}</p>
          </div>
          <div class="category_list clearfix ">
            <gpicker ref="salesman"></gpicker>
          </div>
        </div>
        <div class="fliter_item">
          <!-- 入住起止日期 -->
          <div class="category_name"><span>{{$t('orderList_arr_S')}}</span></div>
          <div class="category_list clearfix ">
            <datepicker v-model="searchOption.arr"
                        class="picker picker-range"
                        :min="start"
                        :max="end"
                        ref='datepicker1'
                        :range="true"></datepicker>
            <div class="tip"><i class="iconfont icon-gantan"></i> {{$t('orderList_tip')}}</div>
          </div>
        </div>
        <div class="fliter_item">
          <!-- 离店起止日期 -->
          <div class="category_name"><span>{{$t('orderList_dep_S')}}</span></div>
          <div class="category_list clearfix ">
            <datepicker v-model="searchOption.dep"
                        class="picker picker-range"
                        :min="start"
                        :max="end"
                        ref='datepicker2'
                        :range="true"></datepicker>
            <div class="tip"><i class="iconfont icon-gantan"></i> {{$t('orderList_tip')}}</div>
          </div>
        </div>

        <div class="bottom_f">
          <!-- 重置 -->
          <div class="reset"
               @click='reset'>{{$t('reset')}}
          </div>
          <!-- 完成 -->
          <div class="success"
               @click='getSum();getOrderListNew()'>{{$t('complete')}}
          </div>
        </div>
      </div>
    </mt-popup>

  </div>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment';
  import nothing from '../common/nothing';
  import {InfiniteScroll} from 'mint-ui';
  import Datepicker from '../common/Datepicker';
  import gpicker from '../common/gpicker';

  export default {
    data() {
      return {
        orderList: null,
        searchTop: 0,
        PosiTop: 0,
        totalCount: '',
        scrollTop: '',
        fixPosition: 0,
        loading: false,
        hasDx: false,
        listHeight: '',
        fixedTwo: false,
        searchPosition: false,
        listLen: '',
        preScroll: '',

        popupVisible3: false,
        start: moment().format('YYYY-MM-DD'),
        end: moment()
          .add(6, 'M')
          .format('YYYY-MM-DD'),
        searchOption: {
          searchText: '',
          arr: ['', ''],
          dep: ['', ''],
          currentPage: 1,
          pageSize: 20,
          salesman: null,
          index: localStorage.orderListTab || 1
        },
        minDate: moment(
          moment()
            .add(-1, 'D')
            .format('YYYY-MM-DD')
        ).toDate(),
        minDate2: moment(moment().format('YYYY-MM-DD')).toDate(),
        maxDate: moment(
          moment()
            .add(6, 'M')
            .format('YYYY-MM-DD')
        ).toDate(),
        stateNum: {
          allReservePeople: 0,
          allReserveRoom: 0,
          hasArrPeople: 0,
          hasArrRoom: 0,
          allHasArrPeople: 0,
          allHasArrRoom: 0,
          hasDepPeople: 0,
          hasDepRoom: 0,
          notArrPeople: 0,
          notArrRoom: 0,
          notDepPeople: 0,
          notDepRoom: 0,
        },

        /**
         * 散客登记 F
         * 团队登记 G
         * 钟点房 D
         * 消费帐 "H" H暂时不显示
         */
        rsvClassObj: {
          'F': this.$t('orderList_rsvClassF'),
          'D': this.$t('orderList_rsvClassD'),
          'G': this.$t('orderList_rsvClassG')
        },
        OrderCountForRoomNumber: false,
        isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
        todayCreateOrder: localStorage.getItem('todayCreateOrder') == 'yes',

      };
    },
    mounted() {
      this.getSum();
      this.getOrderList();
      this.getsaleName();
      this.OrderCountForRoomNumber = localStorage.getItem('OrderCountForRoomNumber') == 'yes'
      //监听页面的滚动条
      document
        .getElementsByClassName('orderList-page')[0]
        .addEventListener('scroll', this.handleScroll);
    },
    methods: {
      toggleDetail(item) {
        item.showOther = !item.showOther
      },
      getSum() {
        this.searchOption.salesman = this.$refs.salesman.getValue();
        this.$http
          .post('/mobilepmsapi/reception/getOrderListSum', this.searchOption, {
            nopost: true
          })
          .then(res => {
            if (res.data.result == 0) {
              this.stateNum = res.data.retVal || {}
            }
          });
      },
      getsaleName() {
        this.$http.get('/mobilepmsapi/sys/pmsPrarms?type=SALES_MAN').then(res => {
          if (res.data.result == 0) {
            this.$refs.salesman.setData(res.data.retVal, null, this.disCodeName);
          }
        });
      },
      disCodeName(v) {
        return v.code + ' -- ' + v.name;
      },
      getOrderListNew() {
        this.orderList = null;
        this.hasDx = false;
        this.popupVisible3 = false;
        this.searchOption.salesman = this.$refs.salesman.getValue();
        this.getOrderList();
      },
      reset() {
        this.searchOption.arr = ['', ''];
        this.searchOption.dep = ['', ''];
        this.$refs.datepicker1.clear();
        this.$refs.datepicker2.clear();
        this.$refs.salesman.clear();
        this.getOrderListNew();
        this.getSum();
      },
      openPick(p) {
        this.$refs[p].open();
      },
      getOrderList() {
        this.hasDx = false;
        this.$http
          .post('/mobilepmsapi/reception/getOrderList', this.searchOption)
          .then(res => {
            if (res.data.result == 0) {
              if (this.orderList == null) {
                this.orderList = [];
              }
              _.forEach(res.data.retVal.list, (el, key) => {
                el.showOther = false
                this.orderList.push(el);
              });
              this.listLen = res.data.retVal.list.length;
              this.totalCount = res.data.retVal.totalCount;
              this.loading = false;
              if (
                this.listLen < 20 &&
                this.orderList.length > 4 &&
                this.listHeight > 0
              ) {
                this.hasDx = true;
              }
            }
          });
      },
      //滚动条上拉下滑顶部固定事件
      handleScroll() {
        this.searchPosition = false;
        var pxNumber = document.getElementsByClassName('orderList-page')[0].scrollTop;
        this.scrollTop = pxNumber / 37.5;
        // console.log( this.scrollTop)
        this.PosiTop = 0 + 'rem';
        if (this.scrollTop >= 1.04) {
          if (this.preScroll < this.scrollTop) {
            this.fixPosition = 0; //滚动差清零
            this.searchPosition = false; //搜索条不固定
            this.fixedTwo = true; //tab栏目固定
            this.PosiTop = 1.04 + 'rem';
          }
          if (this.preScroll > this.scrollTop) {
            this.searchPosition = true;
            this.fixedTwo = true;
            this.searchTop = 0 + 'rem';
            this.setPosition();
          }
        } else {
          this.fixedTwo = false;
        }
        this.preScroll = this.scrollTop;
      },
      //下拉平滑隐藏搜索条
      setPosition() {
        if (this.fixPosition + (this.preScroll - this.scrollTop) > 1) {
          this.searchTop = 1.04 + 'rem';
          this.PosiTop = 2.32 + 'rem';
          //console.log('固定')
        } else {
          this.searchTop =
            this.fixPosition + (this.preScroll - this.scrollTop) + 'rem';
          this.PosiTop =
            1.28 + this.fixPosition + (this.preScroll - this.scrollTop) + 'rem';
          // console.log('平滑')
        }
        this.fixPosition = this.fixPosition + (this.preScroll - this.scrollTop);
      },

      /*tab切换*/
      getList(index) {
        this.searchOption = {
          searchText: this.searchOption.searchText || '',
          currentPage: 1,
          pageSize: 20,
          index: '1',
          salesman: this.$refs.salesman.getValue()
        }; //切换选项时设置默认条件
        this.orderList = null;
        this.hasDx = false;
        this.searchOption.index = index;
        this.getOrderList();
        localStorage.setItem('orderListTab', this.searchOption.index);
      },
      //以20个数据为界，每20个数据到底加载下一页数据
      getNextPage() {
        if (this.hasDx == false) {
          let sef = this;
          sef.listHeight = document.querySelector('.list').clientHeight;
          var allHeight = document.querySelector('.list').offsetHeight;
          if (
            sef.listHeight == allHeight &&
            this.listLen % 20 == 0 &&
            this.listLen > 2
          ) {
            this.loading = true;
            setTimeout(function () {
              sef.searchOption.currentPage += 1;
              sef.getOrderList();
              this.loading = false;
            }, 1000);
          } else {
          }
        }
      },
      link(order) {
        if (
          this.searchOption.index == 22 ||
          this.searchOption.index == 24 ||
          !order.isReserver
        ) {
          return '/fangTXQ?rsvNo=' + order.rsvNo + '&redirect=/orderList';
        } else return '/orderDetail?rsvNo=' + order.rsvNo;
      }
    },
    filters: {
      dateF(value) {
        return value != '' ? value.replace(/-/g, '/').substring(5, 10) : '';
      },
      fdate(value) {
        return value == null || value == ''
          ? null
          : moment(value).format('YYYY-MM-DD');
      }
    },
    components: {
      nothing,
      Datepicker,
      gpicker
    },
    //去除上移下滑效果的页面的scrollTop监听
    beforeRouteLeave(to, from, next) {
      document
        .getElementsByClassName('orderList-page')[0]
        .removeEventListener('scroll', this.handleScroll);
      next();
    }
  };
</script>

<style lang="less">
  .orderList-page {
    background: #f7f8fa;
    overflow: auto;

    .searchFix {
      position: fixed;
      top: 0;
      z-index: 98;
    }

    .ordertop {
      height: 1.28rem;
      width: 100%;
      margin-top: -1px;
      background: #fff;
      padding: 0.18666667rem 0;
      box-sizing: border-box;
      top: 37px;
      z-index: 98;

      .search {
        margin-left: 0.34666667rem;
        border-radius: 0.44rem;
        width: 5.8rem;
        float: left;
        height: 0.85333333rem;
        background-color: #f7f8fa;
        padding: 0 0.26666667rem;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        i.icon-sousuo {
          vertical-align: bottom;
          font-size: 0.42666667rem;
          color: #ccc;
          line-height: 0.89333333rem;
        }

        input {
          padding-left: 0.2rem;
          width: 3.9rem;
          vertical-align: middle;
          //margin-bottom: 0.13333rem;
          flex: 1;
          height: 0.62666667rem;
          background-color: #f7f8fa;
          outline: 0;
          border: 0;
        }

        .cleartext {
          float: right;
          display: block;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }
        }
      }

      .searchBtn {
        width: 1.73333333rem;
        text-align: center;
        float: left;
        line-height: 0.85333333rem;
        font-size: 0.32rem;
        color: #333333;
      }

      .mint-button {
        height: 100%;
        background: #fff;
        box-shadow: none;
        padding: 0;

        .fliter {
          width: 1.86666667rem;
          float: left;
          font-size: 0.32rem;
          line-height: 0.89333333rem;
          text-align: right;
          box-sizing: border-box;
          color: #5b5b5b;

          .iconfont {
            display: inline-block;
            margin-left: 0.13333333rem;
          }
        }
      }
    }

    .state-num-bar {
      background: #fff;
      margin: 3px 0;
      padding: 5px 10px;
      box-sizing: border-box;
      text-align: right;

      .red {
        color: red;
      }
    }

    .oList {
      padding: 0 5px;

      .posiTwo {
        position: fixed;
        top: 0;
        z-index: 98;
      }

      .tags {
        background-color: #fff;
        height: 0.9067rem;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        margin-top: -1px;
        border-bottom: 3px solid #f7f8fa;
        border-top: 5px solid #f7f8fa;

        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }

        .tag {
          float: left;
          position: relative;
          height: 0.9067rem;
          text-align: center;
          line-height: 34px;
          font-size: 12px;
          color: #333;
          padding: 0 10px;

          &.active:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 30px;
            height: 3px;
            background-color: #f69c2d;
            margin: 0 auto;
          }
        }
      }

      .list {
        width: 100%;
        z-index: 30;
        padding-top: 1px;

        .item {
          &:first-child {
            margin-top: -0.2667rem;
          }

          .detailed {
            width: 100%;
            margin: 12px auto 0;
            line-height: 14px;
            font-size: 12px;
            background-color: #fff;

            .top {
              padding: 6px 8px;
              border-bottom: 1px dashed #ddd;
              border-top: 3px solid #d2d6de;

              .left {
                float: left;
              }

              p {
                padding-right: 20px;
                line-height: 16px;
              }

              .right {
                float: right;

                span {
                  color: #d0011b;
                }
              }

              .iconfont {
                float: right;
                color: #666;
              }
            }

            .content {
              padding: 10px 0;
              position: relative;

              .info {
                color: #333;
                float: left;
                box-sizing: border-box;
                height: 22px;
                line-height: 22px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                span {
                  width: 3.2rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .info:nth-of-type(2n-1) {
                width: 45%;
                padding-left: 13px;
              }

              .info:nth-of-type(2n) {
                width: 55%;
              }

              .iconfont {
                position: absolute;
                right: 6px;
                top: ~"calc(50% - 6px)";
                color: #9b9b9b;
              }
            }

            .footer-btn {
              text-align: center;
              padding: 8px;
              color: #666;
              border-top: 1px solid #f7f8fa;
              border-bottom: 1px solid #f7f8fa;
              .iconfont {
                font-size: 14px;
              }

              &:active {
                background: #f7f8fa;
              }

              &.active {
                transform: rotate(180deg)
              }
            }
          }
        }

        .loadingli {
          text-align: center;
          height: 40px;
          line-height: 40px;
        }

        .dx {
          text-align: center;
          height: 20px;
          margin-top: 20px;
          line-height: 20px;
          color: #ccc;
        }
      }
    }

    .mint-popup-3 {
      width: 6.13333333rem;
      height: 100%;

      .rightFliterBox {
        overflow: auto;
        width: 6.13333333rem;
        height: 100%;
        top: 0;
        background-color: #fff;
        transition: right 0.5s ease-in-out;
        box-shadow: 0 0.02666667rem 0.4rem #464444;

        .filter_title {
          width: 100%;
          height: 1.2rem;

          .title {
            float: left;
            line-height: 1.2rem;
            font-size: 0.4rem;
            margin-left: 0.4rem;
          }

          .mint-button {
            float: right;
            height: 100%;
            background: #fff;
            box-shadow: none;

            .icon-cuowu {
              float: right;
              margin-right: 0.4rem;
              line-height: 1.2rem;
              font-size: 0.4rem;
            }
          }
        }

        .fliter_item {
          margin-top: 0.4rem;
          padding: 0 0.26666667rem;

          &:nth-last-of-type(2) .category_list {
            border-bottom: 1.33333333rem solid #fff;
          }

          .category_name {
            height: 0.33333333rem;
            margin: 0 0.26666667rem 0.06666667rem;

            .showCategory {
              float: right;
              color: #606060;
              font-size: 0.26666667rem;
            }

            span {
              font-size: 0.32rem;
            }
          }

          .category_list {
            padding: 0.26666667rem 0 0.63333333rem;
            border-bottom: 0.02666667rem solid #efefef;

            .gpicker {
              border: 1px solid #ccc !important;
              padding-left: 0.2rem;
              position: relative;

              .area_ctrl {
                top: 140px;
              }
            }

            .tip {
              color: #bbb;
              text-align: right;
              margin-top: 0.2rem;
            }
          }
        }

        .bottom_f {
          position: fixed;
          width: 6.13333333rem;
          bottom: 0;
          height: 1.2rem;
          padding: 0.26666667rem 0;
          box-sizing: border-box;
          color: #fff;
          background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
          background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
          background-image: linear-gradient(to left, #ff5a51, #ffa500);

          .reset {
            float: left;
            text-align: center;
            font-size: 0.42666667rem;
            line-height: 0.66666667rem;
            height: 0.66666667rem;
            width: 50%;
            box-sizing: border-box;
            border-right: 0.02666667rem solid #fff;
          }

          .success {
            float: left;
            width: 50%;
            line-height: 0.66666667rem;
            height: 0.66666667rem;
            text-align: center;
            font-size: 0.42666667rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// orderList.vue?34ae0f2f